var mentions_default = {
  "mentionPalette": "gQkLP",
  "mention": "_2g7qm",
  "mentionViewer": "lDQDg",
  "mentionSuggestionsEntry": "ZTEdu",
  "mentionSuggestionsEntryFocused": "W77fs",
  "mentionSuggestionsEntryText": "zJHVe",
  "mentionSuggestionsEntryAvatar": "OijbY",
  "mentionSuggestions": "WI5iB",
  "cursorDefault": "OM9QN",
  "cursorPointer": "_2cnzG"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
